module.exports = __webpack_public_path__ + "img/12-ค่างานทะเบียน.21e0b06f.jpg";